import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  campusId:any;
  classId:any;
  streamId:any;
  campusTrackId:any;
  classname:any;
 city: any;
 campus: any;
 classobject: any;
 stream: any;
 group: any;
 coursetrack: any;
 courseFeeID:any;
 editornot: any;
 checkdelete: any; 
  citylist: any;
  campuslist: any;
  classlist: any;
  streamlist: any;
  grouplist: any;
  coursetracklist: any;
  constructor(){}
  showComponent1 = true;
  showComponent2 = false;
   
  
 

  setData(  campusId:any, classId:any, streamId:any, campusTrackId:any, classname:any)
  {
    this.campusId=campusId;
    this.classId=classId;
    this.campusTrackId=campusTrackId;
    this.streamId=streamId;
    this.classname=classname;
  }
  setfirstpageonjects(city:any,campus:any,classobject:any,stream:any,group:any,coursetrack:any)
  {
    this.city=city
    this.campus=campus
    this.classobject=classobject
    this.stream=stream
    this.group=group
    this.coursetrack=coursetrack
  }
  getCity()
  {
    return this.city
  }
  getCampus()
  {
    return this.campus
  }
  getclass()
  {
    return this.classobject
  }
  getStream()
  {
    return this.stream
  }
  getGroup(){
    return this.group
  }
  getCourseTrack()
  {
    return this.coursetrack
  }
  getcityName()
  {
    return this.city.cityName;
   
  }
  setCity(city:any)
  {
    this.city=city;
  }
  setCampus(Campus:any)
  {
    this.campus=Campus;
  }
  setClass(Class:any)
  {
    this.classobject=Class;
  }
  setStream(stream:any)
  {
    this.stream=stream;
  }
  setGroup(group:any)
  {
    this.group=group;
  }
  setcoursetrack(coursetrack:any)
  {
    this.coursetrack=coursetrack;
  }
  setCityID(city:any)
  {
    this.city=city;
  }
  setCampusID(Campus:any)
  {
    this.campusId=Campus;
  }
  setClassID(Class:any)
  {
    this.classId=Class;
  }
  setcheckdelete(value:boolean){
    this.checkdelete=value
  }
  getcheckdelete()
  {
    return this.checkdelete
  }
  setStreamID(stream:any)
  {
    this.streamId=stream;
  }
  setGroupID(group:any)
  {
    this.group=group;
  }
  setcoursetrackID(coursetrack:any)
  {
    this.campusTrackId=coursetrack;
  }
  getcampusName()
  {
    return this.campus.campusName;
  }
  getclassName()
  {
    return this.classobject.className;
  }
  getgroupName()
  {
    return this.group.groupName;
  }
  getstreamName()
  {
    return this.stream.streamName;
  }
  getcoursetrackName()
  {
    return this.coursetrack.courseTrackName;
  }
  setCityLIst(list:any)
  {
    this.citylist=list
  }
  setCampusLIst(list:any)
  {
    this.campuslist=list
  }
  setClassLIst(list:any)
  {
    this.classlist=list
  }
  setStreamLIst(list:any)
  {
    this.streamlist=list
  }  
  setGroupLIst(list:any)
  {
    this.grouplist=list
  }
  setCourseTrackLIst(list:any)
  {
    this.coursetracklist=list
  }
  getCityLIst()
  {
    return this.citylist
  }
  getCampusLIst()
  {
    return this.campuslist
  }
  getClassLIst()
  {
    return this.classlist
  }
  getStreamLIst()
  {
    return this.streamlist
  }  
  getGroupLIst()
  {
    return this.grouplist
  }
  getCourseTrackLIst()
  {
    return this.coursetracklist
  }
}
